import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { hasText, t } from '@/lib/text'
import { routeForPath } from '../routes'
import { titleWithEnvironment } from './environment'

/** Sets document.title from the route's nav label or screen title, e.g. "Users · PC Forms CRM". */
export function useScreenTitle(explicit?: string) {
  const { pathname } = useLocation()
  useEffect(() => {
    const route = routeForPath(pathname)
    const key = route?.nav?.labelKey ?? (route ? `${route.screenKey}.title` : undefined)
    const screen = explicit ?? (key && hasText(key) ? t(key) : undefined)
    document.title = titleWithEnvironment(screen ? `${screen} · ${t('core.shell.app_name')}` : t('core.shell.app_name'))
  }, [pathname, explicit])
}
